const room_identifier = {
    surgery_school: 'virtual_school',
    npac: 'npac',
}

const constants = {
    room_identifier,
}

export default constants